import React from 'react';
import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import Pictorials from 'components/Pictorial/pictorials';
import { SectionBenefitsCampaigns } from 'components';

export const Benefits = ({ version }: { version: 'new_users' | 'family' }) => {
    const featuresList =
        version === 'new_users'
            ? [
                  {
                      icon: Pictorials.AllInstruments,
                      name: i18n._(t`Learn all 5 instruments`),
                      description: i18n._(
                          t`Learn <b>guitar, ukulele, bass, piano, or vocals</b> with full access to lessons and songs for every instrument.`,
                      ),
                  },
                  {
                      icon: Pictorials.Play,
                      name: i18n._(t`Play as much <br> as you want`),
                      description: i18n._(
                          t`Learn at your own pace with unlimited, interruption-free practice time.`,
                      ),
                  },
                  {
                      icon: Pictorials.Guitars,
                      name: i18n._(t`You play, the app listens`),
                      description: i18n._(
                          t`Play along with fun interactive lessons, get real-time feedback, and improve your skills.`,
                      ),
                  },
              ]
            : [
                  {
                      icon: Pictorials.AllInstruments,
                      name: i18n._(t`1 plan, 4 accounts`),
                      description: i18n._(
                          t`Learn as a family with 4 Premium+ accounts for family members living under one roof. `,
                      ),
                  },
                  {
                      icon: Pictorials.Play,
                      name: i18n._(t`Personal progress tracking`),
                      description: i18n._(
                          t`Each account has individual, unlimited access to all lessons and songs for all instruments-plus personal progress tracking.`,
                      ),
                  },
                  {
                      icon: Pictorials.Guitars,
                      name: i18n._(t`Lessons for all levels`),
                      description: i18n._(
                          t`No experience needed! With lessons and songs for all skill levels, everyone can join in on the fun.`,
                      ),
                  },
              ];
    return (
        <SectionBenefitsCampaigns
            showTitle={false}
            background="white"
            featuresList={featuresList}
        />
    );
};
